"use strict";

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _immutableJsPredicates = require("../internal/immutableJsPredicates");

var _unmutablePredicates = require("../internal/unmutablePredicates");

var _isObject = _interopRequireDefault(require("../util/isObject"));

var error = function error(name, value) {
  throw new TypeError("Unmutable ".concat(name, "() cannot be called with a value of ").concat(value));
};

var UNMUTABLE_COMPATIBLE_TYPE = {
  type: "unmutable",
  isType: function isType(value) {
    return (0, _unmutablePredicates.isUnmutableCompatible)(value);
  },
  fn: function fn(name, ignore, all) {
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return function (value) {
        if (!value[name]) {
          if (all) {
            return all.apply(void 0, args)(value);
          }

          error(name, value);
        }

        return value[name].apply(value, args);
      };
    };
  }
};
var PREP_TYPES = [{
  type: "record",
  isType: function isType(value) {
    return (0, _immutableJsPredicates.isRecord)(value);
  },
  fn: function fn(name, record) {
    return typeof record === 'string' ? function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return function (value) {
        return value[record].apply(value, args);
      };
    } : record;
  }
}, {
  type: "immutable",
  isType: function isType(value) {
    return (0, _immutableJsPredicates._isImmutableNoRecordChecks)(value);
  },
  fn: function fn(name, immutable) {
    return typeof immutable === 'string' ? function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return function (value) {
        if (!value[immutable]) {
          error(name, value);
        }

        return value[immutable].apply(value, args);
      };
    } : immutable;
  }
}, {
  type: "array",
  isType: function isType(value) {
    return Array.isArray(value);
  },
  fn: function fn(name, array) {
    return array;
  }
}, {
  type: "object",
  isType: _isObject["default"],
  fn: function fn(name, object) {
    return object;
  }
}, {
  type: "all",
  isType: function isType() {
    return true;
  },
  fn: function fn(name, all) {
    return all;
  }
}];

var _default = function _default(config) {
  var types = [UNMUTABLE_COMPATIBLE_TYPE].concat((0, _toConsumableArray2["default"])(PREP_TYPES.filter(function (_ref) {
    var type = _ref.type;
    return config[type];
  }))).map(function (_ref2) {
    var type = _ref2.type,
        isType = _ref2.isType,
        fn = _ref2.fn;
    return {
      type: type,
      isType: isType,
      fn: fn(config.name, config[type], config.all)
    };
  });
  return function () {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return function (value) {
      var throwTypeError = function throwTypeError() {
        return error(config.name, value);
      };

      var type = types.find(function (_ref3) {
        var isType = _ref3.isType;
        return isType(value);
      });

      if (type) {
        try {
          return type.fn.apply(type, args)(value);
        } catch (e) {
          if (e.message.startsWith('Unmutable')) {
            throwTypeError();
          }

          throw e;
        }
      }

      throwTypeError();
    };
  };
};

exports["default"] = _default;